import { ComponentProps } from "react";
import { CachedStateProvider, IControlledMutator, Nullable } from "sonobello.utilities.react";

import { LocalStorageConfigs, loadFromLocal, saveToLocal } from "../../../utils/LocalStorage";
import AppContextValueProvider from "../../App/Compositions/AppContextValueProvider";
import OnLocationChangeNoteUpdater, { INoteUpdaterProps } from "../Components/OnLocationChangeNoteUpdater";
import ComposedUseUpsertCustomerNote from "./ComposedUseUpsertCustomerNote";
import CustomerNoteContentBuilder, { CustomerNoteTagProps } from "./CustomerNoteContentBuilder";

const configuredCustomerNoteUpdater: React.FC<
  INoteUpdaterProps<CustomerNoteTagProps> & IControlledMutator<Nullable<string>>
> = props =>
  OnLocationChangeNoteUpdater({
    ...props,
    noteContentBuilder: CustomerNoteContentBuilder,
    useDispatchNoteUpdate: ComposedUseUpsertCustomerNote
  });

const contextPropsCustomerNoteUpdater: React.FC<IControlledMutator<Nullable<string>>> = AppContextValueProvider<
  INoteUpdaterProps<CustomerNoteTagProps>,
  ComponentProps<typeof configuredCustomerNoteUpdater>
>({
  Component: configuredCustomerNoteUpdater,
  map: ({
    customerCState,
    defaultCenter,
    reservation,
    disqualifyingReasonsCState,
    medicalConclusions,
    medicalForm,
    saveCustomerNoteTrigger
  }) => ({
    eventTrigger: saveCustomerNoteTrigger,
    noteProps: {
      customer: customerCState,
      center: reservation?.center ?? defaultCenter,
      reservation,
      disqualifyingReasons: disqualifyingReasonsCState || [],
      medicalConclusions,
      medicalForm
    } as CustomerNoteTagProps
  })
});

// TODO fix CachedStateProvider, its output type should not have `| null` which forces this type assertion. */
const ComposedCustomerNoteUpdater: React.FC = () =>
  CachedStateProvider({
    // TODO, not composed correctly
    defaultValue: "",
    localStoreKey: LocalStorageConfigs.customerNoteContent.key,
    writeCache: (key, value) => saveToLocal(value!, key),
    getCache: key => loadFromLocal<string>(key) ?? "",
    Component: contextPropsCustomerNoteUpdater
  });

export default ComposedCustomerNoteUpdater;
